import { render, staticRenderFns } from "./HomePostWedding.vue?vue&type=template&id=66a0981c&scoped=true&"
import script from "./HomePostWedding.vue?vue&type=script&lang=js&"
export * from "./HomePostWedding.vue?vue&type=script&lang=js&"
import style0 from "./HomePostWedding.vue?vue&type=style&index=0&id=66a0981c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a0981c",
  null
  
)

export default component.exports